var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSnapperCard = function SvgSnapperCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "currentColor",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01 7.64c.43 0 .83.31.83.85s-.4.85-.83.85-.83-.31-.83-.85.4-.85.83-.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.24 8.16-1.91-1.87c-1.11-1.08-2.71-1.76-4.48-1.76-3.36 0-6.09 2.45-6.09 5.47s2.73 5.47 6.09 5.47c1.78 0 3.38-.68 4.49-1.78l2.53-2.44 1.34-1.29 3.8-3.68c.16-.16.25-.38.25-.62a.86.86 0 0 0-.85-.87c-.22 0-.43.09-.58.23l-3.84 3.73-1.34 1.31-2.41 2.35c-.81.83-2.03 1.35-3.39 1.35-2.44 0-4.42-1.69-4.42-3.76s1.98-3.76 4.42-3.76c1.33 0 2.52.5 3.34 1.3l1.85 1.81 1.22-1.19zm2.58 2.52c-.23.22-1 .97-1.23 1.19l3.22 3.15c.15.15.36.25.59.25.47 0 .85-.39.85-.87 0-.24-.1-.47-.26-.62l-3.18-3.1z"
  }))));
};
export default SvgSnapperCard;